import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=01a6110e&scoped=true&lang=pug&"
import script from "./DetailPage.vue?vue&type=script&lang=js&"
export * from "./DetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPage.styl?vue&type=style&index=0&id=01a6110e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6110e",
  null
  
)

export default component.exports